import { useErrorContext } from "../../global/hooks/useErrorContext";
import { IUpdateObjectives } from "../types/interfaces/IUpdateObjectives";
import { IlpData } from "../types/classes/IlpData";

//This custom hook is responsible for making a POST request to the specified api endpoint. Api end point must return IndividualLearningPlan.
export default function useUpdateObjectives(apiEndPoint: string): ((objectives: IlpData<string>) => Promise<IUpdateObjectives | null>) {
    const { setError } = useErrorContext();

    const INELIGIBLE_ERROR_TEXT: string | null = process.env.REACT_APP_ILP_INELIGIBLE_ERROR_TEXT ?? null;

    const handleError = (message: string | null, statusCode: number) => {  
        setError({ message, statusCode });
        return null;
    };

    const postUpdateObjectivesFetch = async (objectives: IlpData<string>): Promise<IUpdateObjectives | null> => {
        try {
            const response = await fetch(apiEndPoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(objectives)
            });
            if (!response.ok) {
                console.log('useUpdateObjectives', response.statusText);
                if (response.status === 401 || response.status === 403) {
                    return handleError(INELIGIBLE_ERROR_TEXT, -response.status);
                } else {
                    return handleError(null, -11);
                }
            }
            const result = await response.json();
            if (!result) {
                return handleError(null, -22);
            } else {
                if (!result.Succeeded && result.Errors !== null) {
                    return handleError(null, -33);
                }
            }
            return result.Data;
        } catch (error: any) {
            console.log('useUpdateObjectives error', error);
            return handleError(null, -error.status);
        } 
    };

    return async (objectives: IlpData<string>) => {
        return postUpdateObjectivesFetch(objectives);
    };
}